module.exports = Jsw.skinUrl + "/images/sticker-collection/sticker/tv.png?26be7c659b1ac2ae6b75883dadcd862b";